import { createContext } from 'react';

export interface UserInfo {
  username: string;
  email: string;
  displayName: string;
  allowed_groups: string[] | null; // null = all access
  is_admin: boolean;
}

export const UserContext = createContext<UserInfo | null>(null);
